<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div style="text-align: left;" class="clause">
        <p style="margin:0pt"><span style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">&nbsp;</span></p>
        <p style="line-height:26pt; margin:0pt 0pt 12pt; text-align:center"><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">授权承诺书</span></p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt"><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">尊敬的客户</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">：</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">为了维护</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">您</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">的合法权益，请在点击确认本授权承诺书</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">（</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">以下简称</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">“</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">本授权书</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">”）</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">前，仔细阅读本授权书全部内容，以知悉</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">您</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">在业务办理中的权利、义务</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">。</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt"><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">致百望股份有限公司（“贵司”）及贵司关联机构（无锡百商众望数据科技有限公司）（以下简称为“百望”或“被授权人”）：</span>
        </p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">鉴于本人通过被授权人运营的线上平台，包括但不限于</span><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">APP</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">、</span><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">H5</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">页面、公众号等形式（以下简称“线上平台”）</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">使用第三方提供的授信产品</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">，就贵司、贵司关联机构及平台采集、处理、使用和对外提供本人个人信息，本人特此做出如下授权和承诺：</span>
        </p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">一、本人特此承诺并确认，</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">本授权书是本人真实的意思表示，本人同意承担由此带来的一切法律后果。本人通过点击或其他方式确认本授权书，即意味着本人明确同意以数据电文形式签署本授权书，认可本授权书的签署方式及效力。</span>
        </p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">二、本人同意不可撤销地授权，根据具体适用的场景的不同，贵司、贵司关联机构有权基于相应的业务场景以及个人信息处理目的，采集和处理本人</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">的</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">个人信息：</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:normal">1</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">、</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">采集本人的姓名、</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">身份证号码</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">、手机号码、邀请码、验证码以便验证本人身份；</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:normal">2</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">、</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">采集本人的</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">借款金额、借款期限、借款用途</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">、月收入、行业、职业、</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">婚姻状况</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">、学历、居住地区、详细地址、公司名称、企业税号、所在地区、详细地址、常用联系人姓名、常用联系人手机号、与申请人关系、紧急联系人姓名、紧急联系人手机号、与申请人关系以及身份证件信息（包括</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">身份证照片</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">、姓名、</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">身份证号</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">、性别、民族、户籍地址、签发机关、签发日期、失效日期）用于本人的授信申请；</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">3</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">、</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">在提交授信申请时，采集本人的录像、人脸照片以便本人完成人脸识别认证，验证本人的真实身份；</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:normal">4</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">、</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">采集本人的银行卡信息（银行名称、</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">银行卡号</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">、银行预留手机号、短信验证码）以及借款信息（</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">借款金额、借款期限</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">、还款方式、放款方式、银行名称、</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">银行卡号</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">）用于本人支用授信产品并向本人发放资金；</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:normal">5</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">、</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">采集本人的还款信息（贷款产品名称、客户姓名、提款日期、</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">提款金额、本期还款金额、待还金额</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">、还款类型）用于本人进行还款结算。</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">（</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">一</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">）</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">贵司</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">、贵司</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">关联机构</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">有权采集本人在前述所列示的业务场景下的个人信息，并存储、进行数据分析，以提供完整服务。</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">（</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">二</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">）</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">贵司、贵司</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">关联机构</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">有权采集本人在前述所列示的业务场景下的个人信息，进行评估分析、创建本人的用户行为分析和评分模型，以及可以受本人委托向金融机构提供该等评估分析结果和报告，用于本人向金融机构申请金融服务。</span>
        </p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">（</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">三</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">）</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">贵司</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">、贵司</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">关联机构</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">有权经本人授权，将本人在前述所列示的业务场景下的个人信息，提供给第三方，以便第三方向本人提供特定贷款产品的推荐服务。</span>
        </p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">（</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">四</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">）</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">贵司</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">、贵司</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">关联机构</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">有权经本人授权，将本人</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">的授信审批结果【包括订单基本信息类（如订单</span><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">ID</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">）、授信信息类（如授信金额、授信时间、可用额度、年化利率、额度生效</span><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">/</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">失效日、额度状态、拒绝原因）、提款信息类（如放款金额、放款时间、借款期限、放款状态、年化利率、提款</span><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">ID</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">、还款状态）、还款信息类（如还款方式、还款期数、还款状态、应还日期、应还总金额、应还本金、应还利息、应还罚息、待还总金额、待还本金、待还利息、待还罚息）】，共享给推荐本人使用授信产品的上游渠道方，以便进行佣金结算。</span>
        </p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">（</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">五</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">）</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">贵司、关联机构及平台如需向境外传输本人的基本信息，应取得本人的特别授权。</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">三、本人对自身提供的所有信息的真实性、完整性、准确性承担全部责任。</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">四、本人承诺，在使用平台服务过程中实施的所有行为均遵守国家法律、法规及平台的各项规则，不违背社会公共利益或公共道德，不损害他人的合法权益，不对平台上的任何数据作商业性利用，包括但不限于在未经贵司及关联机构事先书面同意的情况下，以复制、传播等任何方式使用平台上展示的资料。</span>
        </p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">五、本人知悉并确认，贵司、关联机构及平台提供服务过程中涉及的所有内容（包括但不限于网页、文字、图片、音频、视频、图表等）的知识产权归贵司、关联机构及平台所有。除另有特别声明外，贵司、关联机构及平台提供相关服务时所依托软件的著作权、专利权及其他知识产权均归贵司、关联机构及平台所有。</span>
        </p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">六、</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">本</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">知悉并确认，贵司</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">、</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">关联机构及平台有权根据需要适时修改本授权书及</span><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">/</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">或其他各类规则，并在平台上公示。本</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">同意，如继续使用平台服务并就更新后的版本重新点击确认，即表示本单位及</span><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">/</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">或相关授权主体理解并接受新修订的授权书和规则。</span></p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">七、</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">本人</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">无条件、不可撤销地承诺，当本</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">的行为涉嫌违反法律法规或违反本授权书及</span><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">/</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">或平台相关规则的，贵司</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">、</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">关联机构及平台有权采取相应措施，包括但不限于直接屏蔽、删除侵权信息，或直接停止提供服务。如本</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">的行为使贵司及关联机构及下属平台遭受任何损失</span><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">(</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">包括但不限于受到第三方的索赔、受到行政管理部门的处罚等</span><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">)</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">，本</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">还应当赔偿或补偿贵司</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">、</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">关联机构及平台遭受的全部损失及发生的全部费用，包括但不限于诉讼费、律师费、保全费等。 </span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">八、本人自愿接收贵司、贵司关联机构及平台，以及与贵司、贵司关联机构合作的金融机构向本人提供的持续短信通知服务（通知的信息包括但不限于验证码信息、贷款结果相关的信息）。如对本人的日常工作造成影响，本人可自行通过短信方式取消订阅。</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal"> </span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">九、本人了解贵司、贵司关联机构及平台的信息异议和投诉处理规定，同意贵司、贵司关联机构及平台自收到本人异议后对相关信息做出存在异议的标注，并自收到异议请求之日起</span><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:normal">20</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">日内进行核查和处理，同时将结果书面答复本人。如贵司、关联机构及平台侵害本人的合法权益，本人有权通过向相关主管部门及其派出机构进行投诉或直接向人民法院起诉的方式进行维权。</span>
        </p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">十、本授权书之解释权归属于百望股份有限公司及其关联机构。</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">十一、本授权书自相关授权主体在平台上点击确认之日起生效，至本人与贵司、贵司关联机构及</span><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:normal">/</span><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">或金融机构的业务关系结束之日终止。</span></p>
        <p style="line-height:21pt; margin:0pt 0pt 12pt; text-align:justify"><span
        style="font-family:宋体; font-size:11pt; font-weight:normal">相关授权主体于平台点击确认本授权书具有下述含义：</span></p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt"><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">相关授权主体的点击系代表本</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">对于本授权书的正式签署。本授权书项下授权、承诺的行为完全是由本</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">独立、自主、谨慎做出。本</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">已仔细阅读上述所有条款，并已特别注意字体加黑的内容。</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">贵司</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">已应本</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">要求对相关条款予以明确解释说明。本</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">对所有条款的含义及相应的法律后果</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">，均</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">已全部通晓并充分理解。本</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">人</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">自愿作出上述授权、承诺和声明</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">。</span></p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt"><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">授权</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">人（姓名）</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">：{{fillData.borrowerName}}</span></p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt"><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">授权人身份证号：{{fillData.borrowerIdentity}}</span></p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt"><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">授权</span><span
        style="font-family:宋体; font-size:11pt; font-weight:bold">日期：{{date}}</span></p>
        <p style="line-height:17pt; margin:0pt 0pt 12pt"><span
        style="font-family:'Times New Roman'; font-size:11pt; font-weight:bold">&nbsp;</span></p>
        </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  name: 'FeildTwo',
  data() {
    return {
      date: moment().format('YYYY-MM-DD'),
    };
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  inject: {
    root: {
      default: null
    },
    bindUserRoot: {
      default: null
    }
  },
  computed: {
    fillData(){
      if(this.root)
      return this.root.fapi.getState()
      return null
    }
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause{
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: "微软雅黑";
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  /* text-indent: 6px; */
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
